
const BodyOfWork = () => {
  return null;
};

export default BodyOfWork;
